import * as 장치 from "../../components/장치";
import type { GetServerSideProps } from "next";
import { 마켓봄_추천하기_Desktop } from "../../components/마켓봄_추천하기_Desktop";
import { 마켓봄_추천하기_Mobile } from "../../components/마켓봄_추천하기_Mobile";
import { Paperlogy } from "../../components/font";

import { loadApplicationPageProps, type ApplicationPageProps } from "../_app";

import { CSR } from "../../components/CSR";
import { LayoutSplitter } from "../../layouts/LayoutSplitter";

type 추천하기Props = {
  장치: 장치.t;
} & ApplicationPageProps;

const 추천하기 = ({ 장치 }: 추천하기Props) => {
  return (
    <>
      <style jsx global>{`
        .linkedin,
        .linkedin input,
        .linkedin textarea,
        .linkedin select,
        .linkedin button {
          font-family: ${Paperlogy.style.fontFamily}, "Noto Sans KR", sans-serif;
        }
      `}</style>
      <CSR>
        <LayoutSplitter
          장치={장치}
          pc={<마켓봄_추천하기_Desktop />}
          mobile={<마켓봄_추천하기_Mobile />}
        />
      </CSR>
    </>
  );
};

export default 추천하기;

export const getServerSideProps: GetServerSideProps<추천하기Props> = async (
  ctx
) => {
  const applicationPageProps = await loadApplicationPageProps(ctx);

  return {
    props: {
      장치: 장치.fromContext(ctx),
      ...applicationPageProps,
    },
  };
};
